module.exports = __webpack_public_path__ + "assets/img/travel-day29.ee67c40e.png";